module.exports = __webpack_public_path__ + "img/checklist.eb5d53af.png";